import React from 'react'

import { IOSDownloadLink } from 'components'

import bg from 'assets/images/app-download-bg.png'
import phoneImage from 'assets/images/appDownloadPhone.png'

const AppDownloadBanner = () => {
  return (
    <div className="py-4 px-0 pt-8 lg:pt-12">
      <div
        className="flex flex-row flex-wrap relative overflow-hidden font-ownersWide font-semibold bg-cover lg:flex-nowrap lg:px-20"
        style={{
          backgroundImage: `url(${bg})`,
        }}
      >
        <div className="relative flex flex-col flex-nowrap items-center justify-between text-center w-full pt-6 mb-8 lg:mb-0 lg:w-7/12 lg:text-left lg:items-start lg:py-24">
          <div className="mb-8 w-72 lg:mb-12 lg:w-auto">
            <div className="text-white text-sm mb-8 relative lg:text-base lg:mb-16">
              ATTRACT FROM YOUR HIGHEST SELF
            </div>
            <h2 className="text-white text-3xl uppercase font-medium max-w-xl lg:text-6xl">
              Join Teleport on iOS
            </h2>
          </div>
          <div>
            <IOSDownloadLink />
          </div>
        </div>
        <div className="relative w-full flex justify-center lg:w-5/12 lg:pt-10 lg:items-end lg:justify-end">
          <img className="w-72 lg:w-96" src={phoneImage} alt="phone" style={{ maxWidth: '90%' }} />
        </div>
      </div>
    </div>
  )
}

export default AppDownloadBanner
